"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Quantity = exports.OrderProductPlusWrapper = exports.OrderProductItemWrapper = exports.OrderProductBase = exports.OrderItemProductsWrapper = exports.OnlyMobile = exports.OnlyDesktop = void 0;
var _mui = require("@ori-ui/mui");
const OrderItemProductsWrapper = exports.OrderItemProductsWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        marginTop: theme.spacing(5)
    };
});
const OnlyMobile = exports.OnlyMobile = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        [theme.breakpoints.up('sm')]: {
            display: 'none'
        }
    };
});
const OnlyDesktop = exports.OnlyDesktop = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        [theme.breakpoints.down('sm')]: {
            display: 'none'
        }
    };
});
const OrderProductItemWrapper = exports.OrderProductItemWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        position: 'relative',
        marginRight: theme.spacing(1),
        width: 80,
        display: 'inline-grid',
        '&:last-child': {
            marginRight: '0'
        }
    };
});
const Quantity = exports.Quantity = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        position: 'absolute',
        bottom: theme.spacing(1),
        right: theme.spacing(1),
        width: 32,
        height: 32,
        lineHeight: '32px',
        fontWeight: 'bold',
        background: theme.palette.background.paper,
        borderRadius: 16,
        textAlign: 'center',
        cursor: 'default'
    };
});
const OrderProductBase = exports.OrderProductBase = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        borderRadius: theme.shape.borderRadius,
        boxSizing: 'border-box',
        overflow: 'hidden'
    };
});
const OrderProductPlusWrapper = exports.OrderProductPlusWrapper = (0, _mui.styled)(OrderProductBase)((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '80px',
        height: '80px',
        border: "1px solid ".concat(theme.palette.grey[200]),
        background: theme.palette.background.paper
    };
});
